import type { CmsProduct } from '../../types/cmsProduct';
import type { StateSchema } from '../../utils/helpers/types';

/** Query key (prefixed `cms_` by the URL-state hooks) that carries the selected product uids. */
export const COMPARE_PARAM = 'compare';

export type CompareUrlState = { [COMPARE_PARAM]: string[] };

export const COMPARE_URL_SCHEMA: StateSchema<CompareUrlState> = {
  [COMPARE_PARAM]: 'string[]',
};

/**
 * The identity a plan carries in the URL and the selection: `productUid` (`HK.TI.…`), which the
 * card already exposes as `product.uid`. `entryUID` is the Contentstack/documentId and only a
 * fallback for legacy products that lack the naming-convention uid.
 */
export function compareIdOf(
  product: CmsProduct | undefined,
): string | undefined {
  return product?.uid || product?.entryUID || undefined;
}

/** De-duplicates and drops blanks, keeping first-seen order. */
export function normalizeCompareIds(
  ids: readonly (string | undefined | null)[],
): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const raw of ids) {
    const id = raw?.trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    result.push(id);
  }
  return result;
}
